import { render, staticRenderFns } from "./EvaluationPrix.vue?vue&type=template&id=e5473e74"
import script from "./EvaluationPrix.vue?vue&type=script&lang=js"
export * from "./EvaluationPrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports